export const NUMERIC_REGEX = '^[0-9]*$';
